import React, { useEffect } from "react";

const TitleComponent = ({ title }) => {
  let defaultTitle = "BRH-EMS";

  useEffect(() => {
    document.title = title ? defaultTitle + " \u00BB " + title : defaultTitle;
  }, [title]);

  return null;
};

export default TitleComponent;
